import React, { Fragment } from "react"
import { Link } from "./Link"
import { Button as ChakraButton, ButtonProps } from "@chakra-ui/react"

export interface WildButtonProps extends ButtonProps {
  to?: string | null
  children: React.ReactNode
}

const Button = React.forwardRef(
  ({ to, children, ...rest }: WildButtonProps, ref: any) => {
    const Wrapper: any = to ? Link : Fragment

    return (
      <Wrapper to={to}>
        <ChakraButton ref={ref} {...rest}>
          {children}
        </ChakraButton>
      </Wrapper>
    )
  }
)

export default Button
